import { render, staticRenderFns } from "./CanCompileTargetQuestion.vue?vue&type=template&id=61e63d0e&scoped=true"
import script from "./CanCompileTargetQuestion.vue?vue&type=script&lang=js"
export * from "./CanCompileTargetQuestion.vue?vue&type=script&lang=js"
import style0 from "./CanCompileTargetQuestion.vue?vue&type=style&index=0&id=61e63d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e63d0e",
  null
  
)

export default component.exports